import type { Result } from "neverthrow";

export enum CompanyStatus{
    Desactivado = 0,
    Activado = 1
}

export type Company = {
    id: number;
    nombre: string;
    fechaCreacion: string;
    fechaActualizacion: string;
    estatus: CompanyStatus
}

export type CreateCompanyPayload = {
    nombre: string;
}

export type UpdateCompanyPayload  =  CreateCompanyPayload & {
    id: number
}

export type UpdateCompanyEstatusPayload = {
    id: number
    action: 'active' | 'inactive'
}

export type CreateCompanyResult = Promise<Result<boolean, Error>>
export type UpdateCompanyResult = Promise<Result<boolean, Error>>
export type DeleteCompanyResult = Promise<Result<boolean, Error>>


export type CompanyValues = {
    nombre: string;

}